import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { router } from 'core/Root'
import { routes } from 'routes/index'
import { getAll as getFolderHistory } from '../folderHistory/slice'
import * as api from './api'
import { addToast } from 'services/toast/slice'

export const get = createAsyncThunk('paymentInformation/GET', async (request, thunkAPI) => {
  const { data, error } = await api.get(request)
  if (error) return thunkAPI.rejectWithValue(error)
  else {
    return data
  }
})

export const update = createAsyncThunk('paymentInformation/POST', async (values, thunkAPI) => {
  const { data, error } = await api.update(values)
  if (error) {
    thunkAPI.dispatch(addToast({ type: 'failure', message: error.errorCode }))
    return thunkAPI.rejectWithValue(error)
  } else {
    const { id, archiverId } = thunkAPI.getState().folder?.model ?? {}
    thunkAPI.dispatch(getFolderHistory(id))
    thunkAPI.dispatch(get(archiverId))
    const pathToNavigate = routes.folderDetails.path.replace(':id', id)
    router.navigate(pathToNavigate, { state: router?.state?.location?.state })

    return data
  }
})

const initialState = {
  model: null,
  isModelLoading: false,
  error: null,
  isUpdating: false,
}

const slice = createSlice({
  name: 'paymentInformation',
  initialState: initialState,
  reducers: {
    clearError: state => {
      state.error = null
    },
  },
  extraReducers: builder => {
    builder
      .addCase(get.pending, state => {
        state.isModelLoading = true
        state.error = null
      })
      .addCase(get.fulfilled, (state, action) => {
        state.isModelLoading = false
        state.model = action.payload
      })
      .addCase(get.rejected, (state, action) => {
        state.isModelLoading = false
        state.error = action.error
      })
      .addCase(update.pending, state => {
        state.isUpdating = true
        state.error = null
      })
      .addCase(update.fulfilled, (state, action) => {
        state.isUpdating = false
        state.model = action.payload
      })
      .addCase(update.rejected, (state, action) => {
        state.isUpdating = false
        state.error = action.payload
      })
  },
})

export const { clearError } = slice.actions

export const modelSelector = state => state.paymentInformation.model
export const isModelLoadingSelector = state => state.paymentInformation.isModelLoading
export const isUpdatingSelector = state => state.paymentInformation.isUpdating
export const errorSelector = state => state.paymentInformation.error
export const reducer = slice.reducer
